"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  announcements_a4b8ed4a: {
    message: "Lajm\xEBrime"
  },
  assignments_1e02582c: {
    message: "Detyrat"
  },
  course_syllabus_5de1b0af: {
    message: "Planpogrami i Kursit"
  },
  discussions_a5f96392: {
    message: "Diskutimet"
  },
  files_c300e900: {
    message: "Skedar\xEBt"
  },
  files_index_af7c662b: {
    message: "Indeksi i skedar\xEBve"
  },
  grades_a61eba0a: {
    message: "Notat"
  },
  loading_25990131: {
    message: "Duke u ngarkuar..."
  },
  pages_e5414c2c: {
    message: "Faqet"
  },
  people_b4ebb13c: {
    message: "Njer\xEBz"
  },
  quizzes_7e598f57: {
    message: "Kuizet"
  },
  search_280d00bd: {
    message: "K\xEBrko"
  },
  upload_8b403d05: {
    message: "Ngarko"
  }
};

_formatMessage.default.addLocale({
  sq: locale
});